import React, { useContext, useEffect } from 'react';
import {
  IonPage,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardContent,
} from '@ionic/react';
import { Link } from '@material-ui/core';
import Copyright from '../components/Copyright';
import Header from '../components/Header';

const SuccessUpdate = () => {
  return (
    <IonPage>
      <Header title="Thank you" />
      <IonContent>
        <IonTitle>
          <IonCard>
            <IonCardContent>
              レッスンの更新が完了しました。
              <br />
              次回の更新日になりましたら、新しいチケットがご利用いただけます。
              <br />
              <br />
              料金は次回の更新日から自動的に変更されます。
              <br />
              <br />
              残りのチケットがございましたら、次回の更新日の前日までご利用可能のままでございます。
              <br />
              <br />
              講師検索より、お好きな講師をお選びいただき、
              <br />
              レッスンをご予約ください。
              <br />
              <br />
              <Link href="/teachers">{'講師検索へ進む'}</Link>
            </IonCardContent>
          </IonCard>
        </IonTitle>
        <img src="./img/success_stripe_background.svg" alt="" />
        <Copyright />
      </IonContent>
    </IonPage>
  );
};

export default SuccessUpdate;
